const CargaAR = () => import('@/mfes/importacoes/views/CargaAR');

export default [
    { path: 'carga_ar', name: 'CargaAR', component: CargaAR, meta: { title: 'Carga AR' } },
];
